<template>
  <div>
    <v-row class="d-flex">
      <v-col cols="3">
        <source-filter
          store="newsRadar"
          :exclude="externalSources"
          :multiple="false"
        />
      </v-col>
      <v-col cols="3">
        <site-filter
          store="newsRadar"
          :multiple="false"
          :dependsOnSiteGroups="false"
        />
      </v-col>
      <v-col cols="6">
        <config-filter :site="site" store="newsRadar" />
      </v-col>
    </v-row>
    <v-row>
      <v-col cols="10">
        <origin-filter :site="site" :sources="source" />
      </v-col>
      <v-col cols="2" class="d-flex">
        <v-spacer />
        <apply-filters :disabled="isLoading" outlined color="secondary" />
      </v-col>
    </v-row>
  </div>
</template>

<script>
import { computed } from "@vue/composition-api";
import isArray from "lodash/isArray";
import isEmpty from "lodash/isEmpty";

import ApplyFilters from "@/components/common/filters/ApplyFilters.vue";
import SiteFilter from "@/components/common/filters/SiteFilter.vue";
import ConfigFilter from "@/components/news-radar/common/filters/ConfigFilter.vue";
import SourceFilter from "@/components/news-radar/common/filters/SourceFilter.vue";
import OriginFilter from "@/components/news-radar/common/filters/OriginFilter.vue";

import useAxios from "@/hooks/useAxios";
import useProxy from "@/hooks/useProxy";
import { NEWS_RADAR_EXTERNAL_SOURCES } from "@/utils/constants";

export default {
  name: "Filters",
  components: {
    ApplyFilters,
    ConfigFilter,
    OriginFilter,
    SiteFilter,
    SourceFilter,
  },
  setup(props, { emit }) {
    const { isLoading } = useAxios();
    const { store } = useProxy();

    // =>  METHODS

    // =>  COMPUTED

    // =>  WATCH
    const site = computed(() => {
      const value = store.getters["newsRadar/getSites"];

      return (isArray(value) && isEmpty(value)) || value === "" ? 0 : value;
    });
    const source = computed(() => {
      const value = store.getters["newsRadar/getSources"];

      return (isArray(value) && isEmpty(value)) || value === "" ? 0 : value;
    });

    // =>  HOOKS

    // =>  DATA
    return {
      externalSources: NEWS_RADAR_EXTERNAL_SOURCES,
      isLoading,
      site,
      source,
    };
  },
};
</script>

<style></style>
